<template>
  <div>
    <div class="pay">
      <div class="buy">
        <div v-show="!this.addressDate.length" class="buy_address_no" @click="goo">
          <span class="address_no_img"><img src="../../assets/images/goods/add.png"/></span>
          <span class="address_no_text">新しいお届け先を登録してください</span>
        </div>
        <div v-show="this.addressDate.length" class="buy_address">
          <p class="buy_address_text"><span>お届け先住所を選択してください</span></p>
          <ul class="buy_addres_main">
            <li>
              <p><span>氏&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名：吴守佩</span></p>
              <p><span>联系方式：15517070262</span></p>
              <p><span>地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：束手待毙在必须先GV在电饭锅和最低就喜欢是你就西餐</span></p>
              <p>
                <button>住所/アドレスを再設定</button>
              </p>
            </li>
          </ul>
        </div>
        <table class="cart_main_table">
          <tr class="tableTrFirst">
            <td>商品画像</td>
            <td>商品名</td>
            <td>商品単価</td>
            <td>商品数量</td>
          </tr>
          <tr class="tableTrTwo">
            <td><span><img src="../../assets/images/goods/cart_goods_img.png"></span></td>
            <td><span>持续吸收性VB</span></td>
            <td><span>￥960</span></td>
            <td><span>X2</span></td>
          </tr>
        </table>
        <div class="buy_goods_footer">
          <span>合計:<label>￥123</label></span>
          <span>共計<label>2</label>点</span>
        </div>
        <div class="buy_btn">
          <button>購入確認</button>
        </div>
      </div>
      <div class="popup">
        <div class="popup_hide">
          <p class="title">配送先</p>
          <div class="add_main">
            <ul>
              <li>地&nbsp;址&nbsp;信&nbsp;息：</li>
              <li>
                <el-cascader :options="options2" @active-item-change="handleItemChange" :props="props"></el-cascader>
              </li>
            </ul>
            <ul>
              <li>詳細住所：</li>
              <li>
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}"
                          placeholder="詳細住所/アドレス情報を入力してください"></el-input>
              </li>
            </ul>
            <ul>
              <li>郵&nbsp;便&nbsp;番&nbsp;号：</li>
              <li>
                <el-input placeholder="如您不清楚邮递区号，请填写000000"></el-input>
              </li>
            </ul>
            <ul>
              <li>受取人の名前：</li>
              <li>
                <el-input placeholder="サイズは25文字を超えない"></el-input>
              </li>
            </ul>
            <ul>
              <li>携&nbsp;帯&nbsp;番&nbsp;号：</li>
              <li>
                <el-input placeholder="電話番号" class="input-with-select"></el-input>
              </li>
            </ul>
            <ul>
              <li></li>
              <li>
                <el-checkbox>よく使うお届け先住所</el-checkbox>
              </li>
            </ul>
            <ul>
              <li></li>
              <li>
                <el-button @click="popup">設定を保存</el-button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="Ppay">
      <p class="PpayTop">
        <span @click="back"><img src="../../assets/images/users/Return.png"></span>
        <span>注文支払い</span>
        <span></span>
      </p>
      <p class="PpaySetAddress" @click="settingAddress" v-show="!this.addressDate.length">
        <span>収納アドレスを設置する</span>
        <span><img src="../../assets/images/goods/qianjin.png"></span>
      </p>
      <div class="PpayAddress" v-show="this.addressDate.length">
        <div class="PpayAddressImg">
          <img src="../../assets/images/goods/address.png">
        </div>
        <div class="PpayAddressText">
          <p>
            <span>姓名：吴守佩</span>
            <span>联系方式：15517070262</span>
          </p>
          <p><span>详细地址：浙江省杭州市余杭区1399号互联网村4号楼1喽</span></p>
        </div>
      </div>
      <div class="PpayGoods">
        <ul class="PpayGoodsNav">
          <li>商品画像</li>
          <li>商品名</li>
          <li>商品単価</li>
          <li>商品数量</li>
        </ul>
        <ul class="PpayGoodsContent">
          <li><img src="../../assets/images/goods/cart_goods_img.png"></li>
          <li><p><span>持续吸收型VB</span></p></li>
          <li><p><span>X2</span></p></li>
          <li><p><span>￥960</span></p></li>
        </ul>
      </div>
      <div class="PpayFooter">
        <span>合計：<label>132円</label></span>
        <span>ただちに購入する</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default{
    name: "",
    data(){
      return {
        addressDate: [],
        options2: [
          {
            label: '江苏',
            cities: []
          },
          {
            label: '浙江',
            cities: []
          }],
        props: {
          value: 'label',
          children: 'cities'
        }
      }
    },
    created(){
      this.goods_id = this.$route.query.goods_id;
    },
    methods: {
      back(){
        this.$router.go(-1)
      },
      settingAddress(){
        this.$router.push({path: "/personal/address"})
      },
      goo: function () {
        $('.popup').show();
      },
      popup: function () {
        $('.popup').hide();
      },
      handleItemChange(val) {
        console.log('active item:', val);
        setTimeout(_ => {
          if (val.indexOf('江苏') > -1 && !this.options2[0].cities.length) {
            this.options2[0].cities = [{
              label: '南京'
            }];
          } else if (val.indexOf('浙江') > -1 && !this.options2[1].cities.length) {
            this.options2[1].cities = [{
              label: '杭州'
            }];
          }
        }, 300);
      }
    },
    components: {},
  }
</script>
<style lang="scss">
  @import "../../../static/pubilc";

  @media screen and(min-width: $min-screen) and(max-width: $P749screen) {
    .Ppay {
      font-size: 14/$default-w+rem;
      .PpayTop {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        height: 50px;
        background-color: $TitColor;
        display: flex;
        justify-content: space-between;
        line-height: 50px;
        color: white;
        span:nth-child(1),
        span:nth-child(3) {
          width: 50px;
          display: inline-block;
          height: 50px;
          img {
            margin-top: 10px;
            margin-left: 10px;
          }
        }
      }
      .PpaySetAddress {
        margin-top: 50px;
        height: 40px;
        line-height: 40px;
        background-color: white;
        border-bottom: 1px solid #dddddd;
        display: flex;
        justify-content: space-between;
        span {
          display: inline-block;
          padding: 0 10px;
          img {
            margin-top: 10px;
          }
        }
      }
      .PpayAddress {
        margin-top: 50px;
        height: 75px;
        width: 98%;
        padding-right: 2%;
        background-color: white;
        border-top: 1px solid #dddddd;
        border-bottom: 1px solid #dddddd;
        display: flex;
        justify-content: space-around;
        .PpayAddressImg {
          height: 100%;
          width: 1rem;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 30px;
            height: 30px;
          }
        }
        .PpayAddressText {
          width: 9rem;
          height: 100%;
          p {
            width: 96%;
            padding: 0 2%;
          }
          p:nth-child(1) {
            height: 25px;
            line-height: 25px;
            display: flex;
            justify-content: space-between;
          }
          p:nth-child(2) {
            height: 50px;
            line-height: 22px;
          }
        }
      }
      .PpayGoods {
        width: 100%;
        height: 130px;
        background-color: white;
        text-align: center;
        margin-top: 5px;
        .PpayGoodsNav {
          height: 29px;
          width: 100%;
          display: flex;
          line-height: 29px;
          justify-content: space-around;
          border-bottom: 1px solid #dddddd;
          li {
            width: 2.5rem;
            height: 100%;
          }
        }
        .PpayGoodsContent {
          height: 100px;
          width: 100%;
          display: flex;
          justify-content: space-around;
          border-bottom: 1px solid #dddddd;
          li {
            width: 25%;
            height: 100%;
            img {
              margin: 5px auto;
            }
            p {
              height: 50px;
              margin-top: 25px;
              display: flex;
              align-items: center;
              span {
                width: 100%;
                text-align: center;
              }
            }
          }
        }
      }
      .PpayFooter {
        height: 35px;
        background-color: white;
        position: fixed;
        bottom: 50px;
        left: 0;
        right: 0;
        line-height: 35px;
        display: flex;
        justify-content: flex-end;
        border-bottom: 1px solid #dddddd;
        span:nth-child(1) {
          width: 3rem;
          label {
            color: #dd6161;
            font-size: 16/$default-w+rem;
          }
        }
        span:nth-child(2) {
          padding: 0 5px;
          background-color: $navcolor;
          color: white;
          text-align: center;
        }
      }
    }
    .pay {
      display: none;
    }
  }

  @media screen and(min-width: $P750screen) {
    .pay {
      .buy {
        width: $minwidth;
        margin: 0 auto;
        background-color: white;
        /*background-color: red;*/
        .buy_address {
          padding-top: 10px;
          width: 100%;
          p {
            letter-spacing: 2px;
            line-height: 20px;
          }
          .buy_address_text {
            height: 30px;
            line-height: 30px;
            span {
              display: inline-block;
              margin-left: 55px;
            }
          }
          .buy_addres_main {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            align-content: space-around;
            background-color: #690;
            li {
              margin: 10px 55px;
              height: 135px;
              width: 278px;
              padding: 0 10px;
              border: 1px solid $fontColor;
              background-color: $bgcolor;
              p {
                padding: 3px 0;
                span {
                  font-size: 14px;
                }
                button {
                  border: none;
                  outline: none;
                  color: white;
                  background-color: $navcolor;
                  padding: 5px 10px;
                }
              }
            }
          }
        }
        .buy_address_no {
          height: 205px;
          width: 200px;
          /*background-color: #960;*/
          span {
            margin: 36px;
            display: inline-block;
            width: 128px;
            height: 128px;
          }
          .address_no_text {
            text-align: center;
            height: 40px;
            position: absolute;
            color: $navcolor;
            z-index: 2;
            margin-top: -40px;
          }
        }
        .cart_main_table {
          width: 100%;
          background-color: $bgcolor;
          border-collapse: collapse;
          tr td {
            width: 136px;
            text-align: center;
            input[type='checkbox'] {
              width: 14px;
              height: 14px;
              -webkit-appearance: none;
              border: 1px solid #7eab1e;
              border-radius: 2px;
              outline: none;
              background-color: white;
              background-image: url("../../assets/images/goods/kong.png");
            }
            input[type='checkbox']:checked {
              background-clip: content-box;
              background-image: url("../../assets/images/goods/dui.png");
            }
          }
          .tableTrFirst {
            height: 50px;
          }
          .tableTrTwo {
            background-color: white;
            border: 1px solid #595758;
            height: 120px;
            .el-input-number {
              width: 100px;
            }
            img {
              display: inline-block;
              width: 86px;
              height: 90px;
            }
          }
        }
        .buy_goods_footer {
          margin-top: 5px;
          height: 30px;
          padding: 10px 0;
          width: 100%;
          background-color: $bgcolor;
          line-height: 30px;
          span {
            margin-right: 10px;
            float: right;
            label {
              padding: 0 5px;
              font-size: 20px;
              color: $navcolor;
            }
          }
        }
        .buy_btn {
          height: 30px;
          width: 100%;
          padding: 15px 0;
          margin-bottom: 20px;
          background-color: #f6f7f9;
          button {
            height: 30px;
            float: right;
            border: none;
            outline: none;
            text-align: center;
            color: white;
            font-size: 16px;
            line-height: 30px;
            background-color: $navcolor;
            padding: 0 10px;
            margin-right: 10px;
            border-radius: 5px;
          }
        }
      }
      .popup {
        /*display: none;*/
        position: fixed;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: 300;
        background: rgba(0, 0, 0, 0.3);
        overflow: auto;
      }
      .popup_hide {
        background-color: white;
        width: 800px;
        margin: 0 auto;
        margin-top: 100px;
        border-radius: 5px;
        .title {
          height: 50px;
          width: 100%;
          background-color: #f2f2f2;
          font-weight: 500;
          text-align: center;
          line-height: 50px;
          letter-spacing: 3px;
          font-size: 20px;
        }
        .add_main {
          width: 80%;
          margin: 30px auto;
          .country {
            height: 40px;
            line-height: 40px;
            background-color: $bgcolor;
            .el-select .el-input__inner {
              background-color: $bgcolor;
              border: none;
            }
          }
          ul {
            height: 60px;
            width: 100%;
            display: flex;
            line-height: 60px;
            justify-content: space-around;
            color: #c0c4cc;
            font-size: 16px;
            li:nth-child(1) {
              width: 25%;
              text-align: right;
            }
            li:nth-child(2) {
              width: 75%;
              position: relative;
              .el-select {
                width: 110px;
              }
              button {
                background-color: #5584ff;
                color: white;
              }
              .el-form {
                position: absolute;
                margin-top: 10px;
                height: 40px;
                width: 100%;
                .el-input {
                  width: 100%;
                }
              }
            }
          }
        }
      }
    }
    .Ppay {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/cart/pay.vue